import { render, staticRenderFns } from "./VariableUnitat.vue?vue&type=template&id=2d01cfe7&"
import script from "./VariableUnitat.vue?vue&type=script&lang=js&"
export * from "./VariableUnitat.vue?vue&type=script&lang=js&"
import style0 from "./VariableUnitat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports